<script setup lang="ts">
import LiveEditorBlocks from './LiveEditorBlocks.vue';
import LiveEditorView from './LiveEditorView.vue';
import LiveEditorEdit from './LiveEditorEdit.vue';
import { useLiveEditorStore } from '@/modules/live-editor/stores/live-editor.store';

const viewport = inject('viewport');
const contentBlockStore = useLiveEditorStore();
</script>

<template>
   <main class="live-editor">
      <div class="hide-scrollbar">
         <LiveEditorBlocks v-if="!contentBlockStore.editingBlock" />
         <LiveEditorEdit v-else :key="contentBlockStore.editingBlock.id" />
      </div>
      <div>
         <LiveEditorView
            :class="['live-editor__view', `live-editor__view--${viewport}`]"
            @on-select="contentBlockStore.startEditing"
            @on-remove="contentBlockStore.removeBlock"
         />
      </div>
   </main>
</template>

<style lang="scss" scoped>
.live-editor {
   display: grid;
   gap: var(--nxt-gutter-large);
   grid-template-columns: 20% 80%;
   height: 100%;

   &__view {
      background-color: var(--nxt-white);
   }

   &__view--desktop {
      width: 100%;
      max-width: none;
   }

   &__view--tablet {
      width: 768px;
      max-width: 100%;
      margin: 0 auto;
   }

   &__view--mobile {
      width: 400px;
      max-width: 100%;
      margin: 0 auto;
   }

   & > div {
      overflow: auto;
   }

   .hide-scrollbar {
      scrollbar-width: none;
      -ms-overflow-style: none;

      & ::-webkit-scrollbar {
         display: none;
         width: 0;
         height: 0;
      }
   }
}

// input backgrounds are var(--nxt-white) in the live-editor,
// the rest of the app is default
:deep(.nxt-text-editor__content),
:deep(.nxt-input__input) {
   background: var(--nxt-white);
}
</style>
